<template>
  <div>
    <b-card-code
      class="mt-2 principal"
    >
      <b-button
        id="btn-excel"
        ref="btnexcel"
        variant="primary"
        size="sm"
        style="margin-right: 1%; background: #37ef00!important; border-color: #37ef00!important;"
        @click="cargarDatosBus(excel_btn='1')"
      >
        <font-awesome-icon icon="fa-solid fa-file-excel" />
      </b-button>
      <b-button
        id="btn-pdf"
        variant="danger"
        size="sm"
        @click="cargarDatosBus(excel_btn='', pdf_btn='1')"
      >
        <font-awesome-icon icon="fa-solid fa-file-pdf" />
      </b-button>
      <form id="formulario-filtro-buses" name="formulario-filtro" class="formulario-filtro" method="">
        <b-row class="mt-2">
          <b-col md="3">
            <b-form-group>
              <label>Placa:</label>
              <b-form-input
                  name="placa"
                v-model="placa"
                placeholder="Buscar por placa"
                type="text"
                class="d-inline-block"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>Marca:</label>
              <b-form-input
                  name="marca"
                v-model="marca"
                placeholder="Buscar por marca"
                type="text"
                class="d-inline-block"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>Modelo:</label>
              <b-form-input
                  name="modelo"
                v-model="modelo"
                placeholder="Buscar por modelo"
                type="text"
                class="d-inline-block"
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>Estado:</label>
              <v-select
                  name="estado"
                id="estado"
                v-model="estado"
                :options="estados"
                :reduce="option => option.value"
                label="text"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            lg="4"
            class="pb-2"
          >
            <b-button
              variant="primary"
              size="sm"
              @click="cargarDatosBus(excel_btn='', pdf_btn='')"
            >
              <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> Consultar
            </b-button>
          </b-col>
        </b-row>
      </form>
    </b-card-code>

    <b-overlay
      :show="mostrarLoader"
      opacity="0.50"
      rounded="sm"
    >
      <b-card-code class="principal">
        <b-col
          cols="12"
          class="pr-0 pl-0 mt-2"
        >
          <b-table
            v-if="items.length>0"
            bordered
            striped
            hover
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(activo)="data">
              <b-badge :variant="activo[1][data.value]">
                {{ activo[0][data.value] }}
              </b-badge>
            </template>
            <template #cell(placa)="data">
              <b-link :to="{name:'editbus', params:{token:data.item.token}}">
                {{ data.value }}
              </b-link>
            </template>
          </b-table>

          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col
          cols="12"
          class="mb-2"
        >
          <b-pagination
            v-if="items.length>0"
            v-model="currentPage"
            :total-rows="items.length"
            :per-page="perPage"
            first-number
            last-number
            :small="true"
            align="center"
            class="mb-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-col>
      </b-card-code>
    </b-overlay>
  </div>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BImg, BCardHeader, BCardGroup, BCardTitle, BLink,
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import { GraphQLClient } from 'graphql-request'
import rutasjson from '@/assets/utils/rutas.json'
import axios from '@axios'
import actions from '@/assets/utils/utils'
import vSelect from 'vue-select'
import $ from 'jquery'

import { BOverlay } from 'bootstrap-vue'
import Vue from "vue";

export default {
  components: {
    BLink,
    BCardHeader,
    BCardGroup,
    BCardTitle,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BImg,
    vSelect,
    BOverlay,
  },
  data() {
    return {
      login_user: '',
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 5,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        {
          key: 'placa', label: 'Placa', thClass: 'text-center', tdClass: 'modelo-cell'
        },
        {
          key: 'marca', label: 'Marca', thClass: 'text-center', tdClass: 'modelo-cell'
        },
        { key: 'modelo', label: 'Modelo', thClass: 'text-center', tdClass: 'modelo-cell' },
        {
          key: 'cantidad_pasajeros', label: 'Capacidad Pasajeros', thClass: 'text-center', tdClass: 'modelo-cell'
        },
        {
          key: 'disco', label: 'Disco', thClass: 'text-center', tdClass: 'modelo-cell'
        },
        {
          key: 'activo', label: 'Activo', thClass: 'text-center', tdClass: 'modelo-cell'
        },
      ],
      items: [],
      activo: [{
        false: 'Inactivo', true: 'Activo',
      },
      {
        false: 'light-secondary', true: 'light-success',
      }],

      placa: '',
      marca: '',
      modelo: '',

      estado: 'all',

      estados: [
        { value: '1', text: 'Activo' },
        { value: '0', text: 'Inactivo' },
        { value: 'all', text: 'Todos' },
      ],
      mostrarLoader: false,
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  created() {
    this.comprobarPermisos()
    $('#btn-excel').remove()
    $('#btn-pdf').remove()
    $('#eliminar-viajes').remove()
    this.setToken()
  },
  mounted() {
    // Set the initial number of items
    actions.setearTitulo('')
    this.cargarDatosBus()
    $('#contenedor-botones').append($('#btn-excel')).append($('#btn-pdf'))
  },
  methods: {
    comprobarPermisos() {
      if (localStorage.getItem('permisos').indexOf('log_bus_consultar') === -1) {
        this.$router.push({ name: 'not-permitted' })
      }
    },
    cargarDatosBus(excel_btn = '', pdf_btn = '') {
      this.mostrarLoader = true
      axios.post('api', {
        query: `query buses($placa: String!, $modelo: String!, $marca: String!, $estado: String!, $excel: String!, $pdf: String!){
                    buses(placa:$placa, modelo:$modelo, marca:$marca, estado:$estado, excel:$excel, pdf:$pdf){
                        buses{
                            token,
                            marca,
                            placa,
                            modelo,
                            disco,
                            cantidad_pasajeros: cantidadPasajeros,
                            activo
                        },
                        dataarchivo,
                        status,
                        message
                    }
                }`,
        variables: {
          placa: this.placa,
          modelo: this.modelo,
          marca: this.marca,
          estado: this.estado,
          excel: excel_btn,
          pdf: pdf_btn,
        },
      }).then(response => {
        if (response.status === 200) {
          if (response.data.data.buses.status === 'success') {
            if (response.data.data.buses.buses) {
              this.items = response.data.data.buses.buses
            } else {
              var data = response.data.data.buses.dataarchivo
              if (excel_btn === "1") {
                actions.cargarArchivos(data, "Buses.xlsx","data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64")
              } else {
                actions.cargarArchivos(data, "Buses.pdf","data:application/pdf;base64")
              }
            }
          }
        }
        this.mostrarLoader = false
      })
    },
    setToken() {
      const usuarioCookie = this.$cookie.get('usuario')
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie)
        this.login_user = user.username
        axios.defaults.headers.common.Authorization = `JWT ${user.token}` // for all requests
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    newBus() {
      this.$router.push({ name: 'formbus' })
    },
  },
}
</script>
<style>
.principal .card-header{
    display: none !important
}
.principal .card-body{
    padding-bottom: 0 !important;
}
@media (min-width: 576px) {
  [dir] .table th,
  [dir] .table td {
    padding-left: 1%;
    padding-right: 1%;
  }
}
.modelo-cell {
  white-space: nowrap;
}
</style>
